import React, { useState } from "react";
import {
  StyleSheet,
  Text,
  View
} from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import ZigzagView from "react-native-zigzag-view";

import ButtonIcon from "../../components/ButonIcon";
import PageTitle from "../../components/PageTitle";
import ReceiptEmail from "../../components/ReceiptEmail";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import { IS_WEB } from "../../services/Config";

export default function PaymentReceipt({ navigation, route }) {
  const receiptData = route.params.payment ?? route.params;
  const vacancyData = route.params.vacancy ?? null
  const [visible, setVisible] = useState(false);

  return (
    <PageTitle title={"RECIBO"} navigation={navigation}>
      <View style={{ alignItems: "center", marginBottom: 8 }}>
        <Icon name="check-decagram" size={64} color={Colors.SUCCESS} />
        <Text style={{ fontSize: Fonts.FONT_SIZE_20 }}>
          Pagamento realizado com sucesso
        </Text>
      </View>
      <ZigzagView
        style={styles.receiptView}
        backgroundColor={Colors.WHITE}
        surfaceColor={Colors.TICKET}
      >
        <View style={{ alignItems: "center" }}>
          {receiptData.customer_receipt ? (
            receiptData.customer_receipt.split("\n").map((line, index) => {
              return (
                <Text
                  key={index}
                  style={{ fontSize: Fonts.FONT_SIZE_16, fontWeight: "700" }}
                >
                  {line.trim()}
                </Text>
              );
            })
          ) : (
            <Text>{"Não encontrado"}</Text>
          )}
        </View>
      </ZigzagView>
      <View style={{ flexDirection: "row", marginTop: 8, justifyContent: "space-between" }}>
        <ButtonIcon colorButton={Colors.WARNING} iconName={"email-outline"} onPress={() => {
          setVisible(true);
        }} size={32} />

        {vacancyData ?
          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <ButtonIcon colorButton={Colors.PRIMARY} iconName={"car-outline"} onPress={() => {
              navigation.navigate("VehiclesList", { idClient: vacancyData.idClient, idContract: vacancyData.idVacancy })
            }} size={32} style={{ marginRight: 8 }} />
            <ButtonIcon colorButton={Colors.PRIMARY} iconName={"card-bulleted"} onPress={() => {
              navigation.navigate("CredentialList", { idClient: vacancyData.idClient, idContract: vacancyData.idVacancy })
            }} size={32} />
          </View> : null}

        {!IS_WEB ? (
          <ButtonIcon colorButton={Colors.SUCCESS} iconName={"home-outline"} onPress={() =>
            navigation.reset({ index: 0, routes: [{ name: "Menu" }] })
          } />
        ) : null}
      </View>

      <ReceiptEmail modalVisible={visible} setModalVisible={setVisible} receiptId={receiptData.id_historic}/>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  receiptView: {
    padding: 8,
    marginVertical: 16,
    flex: 1,
    flexGrow: 1,
    marginHorizontal: 8,
    opacity: 0.9,
  },
});
